export const SET_TRANSFER_RECORD_BATCH = 'SET_TRANSFER_RECORD_BATCH';
export function setTransferRecordBatch(batch) {
  return { batch, type: SET_TRANSFER_RECORD_BATCH };
}
